import type { ReactNode } from "react";
import { Header } from "../home/Header";
import { Footer } from "../home/Footer";

export function LegalLayout({
  eyebrow,
  title,
  description,
  children,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <main>
        <section
          className="w-full"
          style={{
            background:
              "linear-gradient(135deg, #ffffff 0%, #f2f0f6 45%, #e5e2ec 100%)",
          }}
        >
          <div className="mx-auto flex w-full max-w-[900px] flex-col items-center gap-4 px-4 py-14 text-center sm:py-16">
            <span className="reveal reveal-1 rounded-full border border-solid border-[#e9e3f5] bg-white/70 px-5 py-2 text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
              {eyebrow}
            </span>
            <h1 className="reveal reveal-2 text-3xl font-extrabold leading-tight text-brand-purple sm:text-4xl">
              {title}
            </h1>
            {description ? (
              <p className="reveal reveal-3 max-w-[640px] text-base leading-7 text-[#475569]">
                {description}
              </p>
            ) : null}
          </div>
        </section>

        <article className="mx-auto w-full max-w-[840px] px-4 py-16 sm:py-20">
          <div className="flex flex-col gap-10">{children}</div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

export function LegalSection({
  heading,
  children,
}: {
  heading?: string;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-3">
      {heading ? (
        <h2 className="text-xl font-bold text-brand-purple sm:text-2xl">
          {heading}
        </h2>
      ) : null}
      <div className="flex flex-col gap-4 text-sm leading-6 text-[#475569] sm:text-base sm:leading-7">
        {children}
      </div>
    </section>
  );
}

export function LegalNote({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-xl bg-[#fff9f2] px-5 py-4 text-sm leading-6 text-[#9a5b1e]">
      {children}
    </div>
  );
}
